import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const breakePoints = {
    desktop: '1750px',
    laptop: '1187px',
    tablet: '980px',
    mobile: '640px',
};

export const GridConteiner = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 50px 3.66%;
    margin-bottom: 25px;
    width: 100%;

    @media(max-width: ${breakePoints.mobile}) {
        grid-template-columns: 1fr;
        grid-gap: 50px 0;
    }
`;

export const SubscriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

export const DataLink = styled.a`
    margin-top: 20px;
    color: ${COLORS.lightBlue};
    border-bottom: 1px solid ${COLORS.lightBlue};
    width: max-content;
    transition: color .3s ease,border-color .3s ease;

    &:hover {
        color: ${COLORS.lightRed};
        border-bottom: 1px solid ${COLORS.lightRed};
    }
`;

export const DataText = styled.div`
    width: 100%;
    white-space: initial;
    font-size: 16px;
    line-height: 1.5;
    color: ${p => p.isLight
        ? COLORS.white
        : COLORS.black
    };
`;
